import { useQuery } from "@tanstack/react-query";

import { getPerformanceMetrics } from "../api/getPerformanceMetrics";
import { getTotalCallCount } from "../api/getTotalCallCount";

export const useTotalCallCount = () => {
    const { data, isLoading, isError } = useQuery({
        queryKey: [`call-count`],
        queryFn: async () => getTotalCallCount(),
        refetchOnWindowFocus: false,
        retry: 0,
        gcTime: 0,
    });
    return { data, isLoading, isError };
};

export const usePerformanceMetrics = () => {
    const { data, isLoading, isError } = useQuery({
        queryKey: [`performance`],
        queryFn: async () => getPerformanceMetrics(),
        refetchOnWindowFocus: false,
        retry: 0,
        gcTime: 0,
    });
    return { data, isLoading, isError };
};
